import { render } from "./resetPwd.vue?vue&type=template&id=622096b1&scoped=true"
import script from "./resetPwd.vue?vue&type=script&lang=js"
export * from "./resetPwd.vue?vue&type=script&lang=js"

import "./resetPwd.vue?vue&type=style&index=0&id=622096b1&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622096b1"]])

export default __exports__